import { render, staticRenderFns } from "./PromotionStatsView.vue?vue&type=template&id=464e820a"
import script from "./PromotionStatsView.vue?vue&type=script&lang=ts"
export * from "./PromotionStatsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports